import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import {FirebaseService} from '../../../core/services/firebase.service';
import type {MenuItem} from '../../../models/menu-item.model';
import { FormsModule } from '@angular/forms';

export type MenuItemWithId = MenuItem & {id: string};

@Component({
    selector: 'app-menu-template',
    templateUrl: './menu-template.component.html',
    styleUrls: ['./menu-template.component.scss'],
    imports: [FormsModule]
})
export class MenuTemplateComponent {
 firebaseService = inject(FirebaseService);

 @Input() menuItems: MenuItemWithId[] = [];
 @Input() isDeleteVisible = false;
 @Output() deleteMenuTemplate: EventEmitter<MenuItemWithId> = new EventEmitter<MenuItemWithId>();

   _deleteMenuTemplate(item: MenuItemWithId) {
     this.deleteMenuTemplate.emit(item);
   }

   updateMenuItem(m: MenuItemWithId) {
     this.firebaseService.updateMenuItem(m.id, m).then(res => {
         console.warn(res);
     });
   }
}

